

const ServicesData = [
    {
        'title': 'USG',
        'id': 'usg',
    },
    {
        'title': 'Konsultacje lekarskie',
        'id': 'konsultacje-lekarskie',
    },
    {
        'title': 'Zabiegi diagnostyczne',
        'id': 'zabiegi-diagnostyczne',
    },
    {
        'title': 'Zabiegi lecznicze i przeciwbólowe',
        'id': 'zabiegi-lecznicze',
    },
    {
        'title': 'Zabiegi chirurgiczne',
        'id': 'zabiegi-chirurgiczne',
    },
    // {
    //     'title': 'WEEKEND Z PEDIATRĄ',
    //     'id': 'weekend-z-pediatra',
    //     'type': 'yellow'
    // }
]

export default ServicesData;